export default "__VITE_ASSET__D5yh5bt9__"